import { render, staticRenderFns } from "./CookieDeclarationBlock.vue?vue&type=template&id=7d924949&"
import script from "./CookieDeclarationBlock.vue?vue&type=script&lang=ts&"
export * from "./CookieDeclarationBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports